<template>
  <el-container class="bg">
    <el-aside class="left_bg">
      <leftMenuDiv ref="leftMenuDiv"></leftMenuDiv>
    </el-aside>
    <el-main class="content-box">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import { GetAttachmentPath } from "@/api/systemApi.js";
import leftMenuDiv from "./mainIndex/leftMenu.vue";
export default {
  data() {
    return {
      userInfo: {},
      roleInfo: {},
      loading: false,
    };
  },
  components: {
    leftMenuDiv,
  },
  mounted() {
    this.getFileInfoPathData();
    this.userInfo = JSON.parse(localStorage.getItem("setUserInfo")) || {};
  },
  methods: {
    // 获取附件前缀
    getFileInfoPathData() {
      GetAttachmentPath()
        .then((res) => {
          if (res.code === 1) {
            localStorage.setItem("filePath", res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    // 退出登录
    clickLoginout() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        setTimeout(() => {
          if (this.$tabs) {
            this.$tabs.reset();
          }
          localStorage.clear();
          this.$router.replace({
            path: "/login",
          });
          this.$message({
            type: "success",
            message: "已退出登录!",
          });
        }, 300);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  width: 100%;
  background: #ffffff;
  height: calc(100vh - 3.5rem);
}

.left_bg {
  width: 260px !important;
  background: #e5e5e5;
  height: calc(100vh - 3.5rem);
  border: 0px solid rgba(34, 34, 56, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.el-card__body,
.el-main {
  padding: 0px !important;
  // padding-top: 8px !important;
  border: 4px solid #e5e5e5;
  border-left: none;
  overflow: hidden;
}
</style>